import type { StoredLosslessNumber } from '../../../stored-json-number';

export const CLOVER_FORBIDDEN_LOG_DATA_KEYS = [
    'accessToken',
    'apiAccessToken',
    'bearerToken',
    'cardNumber',
    'cardToken',
    'cvv2',
    'expirationDate',
    'expiryDate',
    'expiryMonth',
    'expiryYear',
    'expMonth',
    'expYear',
    'first6',
    'gatewayToken',
    'maskedPan',
    'securityCode',
] as const;

export type CloverForbiddenLogDataKey = (typeof CLOVER_FORBIDDEN_LOG_DATA_KEYS)[number];

export const CloverLoggingRedactionOutcome = {
    REDACTED: 'redacted',
    MALFORMED_INPUT: 'malformed_input',
} as const;

export type CloverLoggingRedactionOutcome =
    (typeof CloverLoggingRedactionOutcome)[keyof typeof CloverLoggingRedactionOutcome];

export interface CloverLoggingRedactionJsonObject {
    readonly [key: string]: CloverLoggingRedactionJsonValue | undefined;
}

export interface CloverLoggingRedactionJsonArray extends ReadonlyArray<CloverLoggingRedactionJsonValue> {}

export type CloverLoggingRedactionJsonValue =
    | string
    | number
    | boolean
    | null
    | StoredLosslessNumber
    | CloverLoggingRedactionJsonObject
    | CloverLoggingRedactionJsonArray;

export interface CloverLoggingRedactionRequestDetails {
    readonly payload: CloverLoggingRedactionJsonValue;
}

export interface CloverLoggingRedactionNormalizedResult {
    readonly redacted_payload: CloverLoggingRedactionJsonValue;
    readonly omitted_sensitive_key_count: number;
}

export type CloverLoggingRedactionResponseDetails =
    | {
          readonly outcome: typeof CloverLoggingRedactionOutcome.REDACTED;
          readonly normalized_result: CloverLoggingRedactionNormalizedResult;
      }
    | {
          readonly outcome: typeof CloverLoggingRedactionOutcome.MALFORMED_INPUT;
          readonly message: string;
          readonly payload?: unknown;
      };
